/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import './collapsibleTable.scss';

const propTypes = {
    expandUsingURLPrimaryKey: PropTypes.bool.isRequired,
    canExpandRow: PropTypes.func.isRequired,
    onRowCheckboxChange: PropTypes.func,
    isBulkMode: PropTypes.bool,
    onToggleBulkMode: PropTypes.func,
    isRowChecked: PropTypes.func,
    expandedRowViewIndex: PropTypes.any,
    bulkModeEnabled: PropTypes.bool,
};

const defaultProps = {
    bulkModeEnabled: true,
    isBulkMode: false,
    onRowCheckboxChange: () => {},
    onToggleBulkMode: () => {
        console.log('Warning: Pass onToggleBulkMode as props for callback');
    },
    isRowChecked: () => {},
    canExpandRow: row => true,
    expandedRowViewIndex: null,
};

class CollapsibleTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedRow: {},
            shiftKeyPressed: false,
        };
        this.documentOnClickCallback = this.documentOnClickCallback.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.documentOnClickCallback);
        document.addEventListener('keydown', this.handleKeyDown);
        document.addEventListener('keyup', this.handleKeyUp);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.documentOnClickCallback);
        document.removeEventListener('keydown', this.handleKeyDown);
        document.removeEventListener('keyup', this.handleKeyUp);
    }

    handleKeyDown(e) {
        if (e.key === 'Shift') {
            this.setState({ shiftKeyPressed: true });
        }
    }

    handleKeyUp(e) {
        if (e.key === 'Shift') {
            this.setState({ shiftKeyPressed: false });
        }
    }

    fireFetchData() {
        this.props.fireFetchData();
    }

    handleRowClick(rowIndex) {
        this.setState({
            expandedRow: {
                [rowIndex]: !this.state.expandedRow[rowIndex],
            },
        });
    }

    documentOnClickCallback(e) {
        let element = e.target;
        while (element && element.tagName !== 'BODY') {
            if (
                element.classList.contains('rt-td') ||
                element.classList.contains('rt-tr-group') ||
                element.classList.contains('icon-close') ||
                element.classList.contains('react-router-modal__backdrop')
            ) {
                return;
            }
            // If modal is being shown on table to collapse row
            if (
                e.currentTarget.body.getElementsByClassName(
                    'react-router-modal__container',
                ).length
            ) {
                return;
            }
            element = element.parentElement;
        }
        if (this.props.onCollapseRow) {
            this.props.onCollapseRow();
        }
        document.removeEventListener('click', this.documentOnClickCallback);
    }

    render() {
        const { props } = this;
        const {
            onRowCheckboxChange,
            onToggleBulkMode,
            isRowChecked,
            isBulkMode,
            bulkModeEnabled,
            expandedRowViewIndex,
            expandUsingURLPrimaryKey,
        } = props;
        const myColumns = [
            {
                Header: () => {
                    if (bulkModeEnabled) {
                        return (
                            <div className="collapsible-table-checker">
                                <i
                                    className={[
                                        'icon',
                                        isBulkMode
                                            ? 'icon-navigation-drawer-2'
                                            : 'icon-check-box-1',
                                    ].join(' ')}
                                    onClick={onToggleBulkMode}
                                    title={
                                        isBulkMode
                                            ? 'Cancel selection'
                                            : 'Select multiple elements'
                                    }
                                />
                            </div>
                        );
                    }
                    return null;
                },
                sortable: false,
                width: '40',
                Cell: rowInfo => {
                    const canExpandRow = this.props.canExpandRow(rowInfo.original);
                    if (canExpandRow) {
                        const checked = isRowChecked
                            ? isRowChecked(rowInfo)
                            : false;
                        if (isBulkMode) {
                            return (
                                <div className="collapsible-table-checker">
                                    <input
                                        className="checkbox-purple"
                                        type="checkbox"
                                        checked={checked}
                                        onChange={e => {
                                            onRowCheckboxChange(
                                                rowInfo,
                                                e.target.checked,
                                                this.state.shiftKeyPressed
                                            );
                                        }}
                                    />
                                </div>
                            );
                        }
                        return (
                            <div
                                className={[
                                    'collapsible-table-expander',
                                    rowInfo.index === expandedRowViewIndex
                                        ? 'active'
                                        : this.state.expandedRow[rowInfo.index]
                                        ? 'active'
                                        : '',
                                ].join(' ')}
                            >
                                <i className="icon icon-arrow-right-12" />
                            </div>
                        );
                    } else if (!canExpandRow && this.state.expandedRow[rowInfo.index]) {
                        this.handleRowClick(rowInfo.index)
                    }
                },
            },
            {
                header: () => null,
                headerStyle: { display: 'none' },
                expander: true,
                width: 0,
                style: { display: 'none' },
            },
        ];

        const getTrProps = (state, rowInfo, col, instance) => ({
            onClick: e => {
                if (this.props.canExpandRow(rowInfo.original)) {
                    document.removeEventListener(
                        'click',
                        this.documentOnClickCallback,
                    );
                    document.addEventListener(
                        'click',
                        this.documentOnClickCallback,
                    );

                    let element = e.target;
                    while (element) {
                        if (element.classList.contains('rt-td')) {
                            break;
                        } else if (element.classList.contains('rt-tr-group')) {
                            return;
                        }
                        const { tagName } = element;
                        if (
                            tagName === 'A' ||
                            tagName === 'INPUT' ||
                            tagName === 'BUTTON' ||
                            tagName === 'SELECT' ||
                            tagName === 'TEXTAREA'
                        ) {
                            return;
                        }
                        element = element.parentElement;
                    }

                    const { isBulkMode, expandedRowViewIndex } = this.props;

                    if (isBulkMode) {
                        const { isRowChecked, onRowCheckboxChange } =
                            this.props;
                        onRowCheckboxChange(rowInfo, !isRowChecked(rowInfo), e.shiftKey);
                        return;
                    }

                    if (expandUsingURLPrimaryKey) {
                        if (rowInfo.viewIndex === expandedRowViewIndex) {
                            this.props.onCollapseRow();
                        } else {
                            this.props.onExpandRow(rowInfo);
                        }
                    } else {
                        this.handleRowClick(rowInfo.index);
                    }
                }
            },
            className: rowInfo.index === expandedRowViewIndex ? 'expanded' : '',
        });

        return (
            <ReactTable
                {...props}
                columns={[...myColumns, ...props.columns]}
                expanded={
                    this.props.expandUsingURLPrimaryKey
                        ? { [this.props.expandedRowViewIndex]: true }
                        : this.state.expandedRow
                }
                getTrProps={getTrProps}
            />
        );
    }
}

CollapsibleTable.propTypes = propTypes;
CollapsibleTable.defaultProps = defaultProps;

export default CollapsibleTable;
